/* unplugin-vue-components disabled */import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { useSettingsStore } from '@/store/modules/settings';
import { useRouter } from 'vue-router';
import navBar from '@/components/navBar';
import { useRoutesStore } from '@/store/modules/routes';
import right from '@/components/right/index.vue';
export default defineComponent({
  name: 'Main',
  components: {
    navBar,
    right
  },
  setup() {
    const settingsStore = useSettingsStore();
    const {
      website
    } = storeToRefs(settingsStore);
    const router = useRouter();
    const routes = useRoutesStore();
    const state = reactive({
      collapse: false,
      //导航栏数据
      navBarList: [],
      navBarActiveUrl: '/user/userList',
      //选中的导航栏下标
      sideBarActiveUrl: '/user/userList',
      //选中的侧边栏下标
      siderBarList: [],
      //侧边栏内容
      breadcrumbList: [],
      //面包屑导航
      website,
      logo: require('@/assets/logo/defineLogo.png')
    });
    watch(() => router.currentRoute.value, current => {
      state.breadcrumbList = current.matched;
      // 存在二级分类页面，但是二级分类页面不显示，改变选中的值为一级分类
      if (current.meta.display == 'none' && current.meta.twoCategroy == 'none') {
        state.sideBarActiveUrl = current.matched[1].path;
      } else {
        state.sideBarActiveUrl = current.fullPath;
      }
    },
    // () => website.value && website.value.site_logo,
    // () => {
    //   ;(state.logo = website.value.site_logo),
    //     console.log(website.value.site_logo, '数据')
    // },
    {
      immediate: true,
      deep: true
    });
    onBeforeMount(() => {
      const routerList = router.currentRoute.value.matched;
      const navBarActiveUrl = routerList[0].path;
      let sideBarActiveUrl = router.currentRoute.value.fullPath;
      let isSymbol = sideBarActiveUrl.lastIndexOf('?');
      if (sideBarActiveUrl && isSymbol != -1) {
        sideBarActiveUrl = sideBarActiveUrl.substring(0, isSymbol);
      }
      const list = routes.routes;
      let sidebarList = [];
      list.forEach(items => {
        if (items.children) {
          items.children.forEach(item => {
            if (item.path == sideBarActiveUrl) {
              sidebarList = items.children;
            }
            if (item.children && item.children.length > 0) {
              item.children.forEach(oneItem => {
                if (oneItem.path == sideBarActiveUrl) {
                  sidebarList = items.children;
                }
              });
            }
          });
        }
      });
      state.navBarActiveUrl = navBarActiveUrl;
      state.navBarList = list;
      state.siderBarList = sidebarList;
      if (website.value) {
        if (website.value.site_logo) state.logo = website.value.site_logo;
      }
    });
    const handleNavBar = async (index, url) => {
      let list = routes.routes;
      let children = list[index] && list[index].children;
      if (!children || children.length === 0) {
        await routes.setRoutes();
        list = routes.routes;
        const newIndex = list.findIndex(item => item.path === url);
        children = newIndex > -1 && list[newIndex].children ? list[newIndex].children : [];
      }
      state.siderBarList = children || [];
      state.navBarActiveUrl = url;
    };
    const clickSiderBar = (index, item) => {
      state.sideBarActiveUrl = item.path;
    };
    return {
      ...toRefs(state),
      handleNavBar,
      clickSiderBar
    };
  }
});